module.exports = __webpack_public_path__ + "img/youtube-logotype.5b04fb20.svg";